import type { ReactElement, ReactNode } from "react";

interface Props {
  icon?: string;
  title: string;
  message: string;
  action?: ReactNode;
}

/** Empty state с иконкой + сообщением + опциональной CTA. */
export function EmptyState({
  icon = "🔍",
  title,
  message,
  action,
}: Props): ReactElement {
  return (
    <section className="empty-state">
      <div className="empty-state__icon" aria-hidden>
        {icon}
      </div>
      <h2 className="empty-state__title">{title}</h2>
      <p className="empty-state__message">{message}</p>
      {action && <div className="empty-state__action">{action}</div>}
    </section>
  );
}
